<template>
  <div
    class="w-full px-[20px] py-[75px] md:p-[100px] bg-no-repeat bg-cover"
    :style="{ backgroundImage: `url(${subHeaderBg})` }"
  >
    <div
      class="flex flex-col gap-[20px] text-center justify-center items-center"
    >
      <span class="text-[24px] md:text-[32px] lg:text-[36px] font-bold"
        ><h1>
          {{ title }}
        </h1></span
      ><span>
        <p class="w-full lg:w-[1000px] text-[16px] md:text-[24px]">
          {{ description }}
        </p>
      </span>
    </div>
  </div>
  <div class="hidden lg:block w-full h-[20px] bg-[#F0F0F0]"></div>
</template>

<script>
import subHeaderBg from "@/assets/pictures/subHeader-bg.png";
export default {
  props: {
    title: { type: String },
    description: { type: String },
  },
  data() {
    return {
      subHeaderBg,
    };
  },
};
</script>

<style></style>
